export const OCEANIA_CODES = [
  "AS",
  "AU",
  "CC",
  "CK",
  "CX",
  "FJ",
  "FM",
  "GU",
  "KI",
  "MH",
  "MP",
  "NC",
  "NF",
  "NR",
  "NU",
  "NZ",
  "PF",
  "PG",
  "PN",
  "PW",
  "SB",
  "TK",
  "TL",
  "TO",
  "TV",
  "UM - DQ",
  "UM - FQ",
  "UM - HQ",
  "UM - JQ",
  "UM - MQ",
  "UM - WQ",
  "VU",
  "WF",
  "WS",
];
